import { i18n } from '@lingui/core';
import { modal as modalClasses } from '@warp-ds/css/component-classes';
import { Button } from '@warp-ds/react';
import React, { type JSX } from 'react';

type LoginTemplateProps = {
    closeCallback: () => void;
    redirectUrl?: string;
};

const LoginTemplate: (
    props: LoginTemplateProps,
) => [JSX.Element, JSX.Element, JSX.Element] = ({
    closeCallback,
    redirectUrl = window.location.href,
}: LoginTemplateProps) => {
    const footer: JSX.Element = (
        <>
            <Button quiet className="mr-8" onClick={closeCallback}>
                {i18n.t({
                    id: 'notNow',
                    message: 'Not now',
                })}
            </Button>
            <Button
                primary
                href={`/auth/login?redirectUrl=${encodeURIComponent(redirectUrl)}`}
            >
                {i18n.t({
                    id: 'login',
                    message: 'Log in',
                })}
            </Button>
        </>
    );
    const body: JSX.Element = (
        <div>
            <p>
                {i18n.t({
                    id: 'loginNudge',
                    message:
                        'Log in to add the listing to your favourites so you can easily find it again, no matter where you are.',
                })}
            </p>
        </div>
    );
    return [
        body,
        footer,
        <h3 className={modalClasses.titleText}>
            {i18n.t({
                id: 'login',
                message: 'Log in',
            })}
        </h3>,
    ];
};

export default LoginTemplate;
